import { render, staticRenderFns } from "./ReviewInputView.vue?vue&type=template&id=0f551c3e&scoped=true&"
import script from "./ReviewInputView.vue?vue&type=script&lang=js&"
export * from "./ReviewInputView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f551c3e",
  null
  
)

export default component.exports